let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iXjr0")).then(() => parcelRequire('jLUA6'));